import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import { GET_PROGRAM_METRICES, GET_PROGRAM_METRICES_ERROR, GET_PROGRAM_METRICES_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getProgramMetrices({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/metrics/program`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParam,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROGRAM_METRICES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROGRAM_METRICES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROGRAM_METRICES_ERROR, payload: error });
  }
}

export function* watchGetProgramMetrices() {
  yield takeEvery(GET_PROGRAM_METRICES, getProgramMetrices);
}

function* getProgramMetricesSaga() {
  yield all([fork(watchGetProgramMetrices)]);
}

export default getProgramMetricesSaga;
